import { IToggleSummary } from '../../../actions/bookingCalendar/calendar/summary'
import { IBookingCalendarStore } from '../index'

export default function(
  state: IBookingCalendarStore,
  action: IToggleSummary,
): IBookingCalendarStore {
  return {
    ...state,
    summary: action.showSummary,
  }
}
